<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="room-type-list content-wrapper">
      <div class="page-header">{{ $t('attachment') }}</div>
      <div>
        <el-row>
          <el-col :span="12" class="upload-container">
            <el-row>
              <el-col :span="20">
                <input-file-component v-model="fileUploadData"
                                      :size="'small'"></input-file-component>
              </el-col>
              <el-col :span="3">
                <el-button type="primary"
                           size="small"
                           :disabled="isDisabledUpload()"
                           icon="el-icon-upload"
                           @click="onUploadButtonClick()">
                  {{$t('upload')}}
                </el-button>
              </el-col>
            </el-row>
          </el-col>
          <div style="margin-left: 60%; padding: 10px 0">
            <el-row>
              <el-col :span="20">
                <el-input
                  :placeholder="$t('keyword')"
                  v-model="keyword"
                  size="small"
                  @input="isSearching = true">
                </el-input>
              </el-col>
              <el-col :span="4">
                <el-button type="default"
                           size="small"
                           style="width: 90%; margin-left: 10px"
                           @click="onClearButtonClick()">
                  {{$t('clear')}}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-row>
        <div v-loading="isLoading || isSearching">
          <hr>
          <div>
            <table class="table-attachment-list" border="0" cellspacing="0" cellpadding="0">
              <tr v-for="(attachment, index) of attachmentDataList" :key="`attachment-${index}`"
                  :class="{'lastest-file':(index === 0)}">
                <td width="5%">{{index + 1}}</td>
                <td width="40%">
                  <div class="signed-document-default"
                       style="float: left; margin-top: 5px; margin-right: 5px;"></div>
                  <div style="float:left">{{getDocumentName(attachment.name)}}</div>
                </td>
                <td width="30%">{{getCreatedAt(attachment.createdAt)}}</td>
                <td width="25%" align="right">
                  <el-button type="primary" size="small" icon="el-icon-download"
                             @click="onDownloadButtonClick(attachment)" plain>
                    {{$t('download')}}
                  </el-button>
                  <el-button type="success" size="small" icon="el-icon-edit"
                             @click="onOpenPopupEditFileNameButtonClick(attachment)"></el-button>
                  <el-button type="danger" size="small" icon="el-icon-delete"
                             @click="onConfirmRemoveButtonClick(attachment)"></el-button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('editFileName')" :visible="isPopupVisible" @close="closePopup()" width="600px">
      <span id="modal-body">
        <el-form ref="form" label-width="150px" style="width: 500px">
          <el-form-item :label="$t('fileName')" :required="true">
            <el-input v-model="editFileName" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </span>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSaveFileNameButtonClick">{{ $t('save') }}</el-button>
        <el-button type="default" @click="closePopup">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Agent/ManageAgent/Attachment/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import AgentAttachmentApi from '@/api/agent/attachment-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import InputFileComponent from '@/components/InputFileComponent'
import { filterDataByKeyword } from '@/services/general-service'
import { dateFormat } from '@/helpers/datetime'
import { forceDownloadFileUrl, delay } from '@/helpers'
import { mapState } from 'vuex'
import { get, debounce } from 'lodash'

export default {
  name: 'Attachment',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, InputFileComponent },
  i18n: { messages: i18nMessages },
  computed: {
    ...mapState({
      activeAgentId: state => state.general.activeAgentId
    })
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
      if (newValue === true && this.specialOfferId !== '') {
        this.initData()
      }
    },
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this._filterAttachmentList()
      }
    }
  },
  created: async function () {
    if (this.activeAgentId === undefined || this.activeAgentId === '') {
      return this.$router.push({
        name: 'AgentList'
      })
    }

    try {
      this.isLoading = true
      this.initAttachmentData()
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  data () {
    return {
      isLoading: true,
      attachmentList: [],
      attachmentDataList: [],
      fileUploadData: {},
      isSearching: false,
      isPopupVisible: false,
      editFileId: '',
      editFileName: '',
      keyword: ''
    }
  },
  methods: {
    initAttachmentData: async function () {
      this.attachmentList = await AgentAttachmentApi.list(this.activeAgentId)
      this._filterAttachmentList()
    },
    isDisabledUpload: function () {
      const fileName = get(this.fileUploadData, 'name', '')
      const content = get(this.fileUploadData, 'content', '')

      if (fileName === '' || content === '') {
        return true
      }

      return false
    },
    onUploadButtonClick: async function () {
      this.startLoading()
      try {
        const data = {
          fileUpload: this.fileUploadData
        }

        await AgentAttachmentApi.uploadAttachment(this.activeAgentId, data)
        await this.initAttachmentData()
        this.fileUploadData = {}

        const title = this.$t('success')
        const message = this.$t('uploadSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }
      this.stopLoading()
    },
    onDownloadButtonClick: async function (attachFile) {
      this.startLoading()

      try {
        const data = {
          fileUrl: attachFile.path
        }

        const documentResult = await AgentAttachmentApi.downloadAttachment(this.activeAgentId, data)
        const documentData = `data:${attachFile.mimeType}; base64, ${documentResult}`

        forceDownloadFileUrl(documentData, attachFile.name)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onConfirmRemoveButtonClick: async function (attachFile) {
      const confirmMessage = this.$t('confirmDeleteFileMessage', {
        attachFile: attachFile.name
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      await this._removeAttachmentFile(attachFile)
    },
    onOpenPopupEditFileNameButtonClick: function (attachment) {
      this.editFileId = attachment.id
      this.editFileName = attachment.name

      this.isPopupVisible = true
    },
    closePopup: function () {
      this.isPopupVisible = false
    },
    onSaveFileNameButtonClick: async function () {
      if (!this._validateData()) {
        return false
      }

      try {
        this.startLoading()

        const data = {
          id: this.editFileId,
          fileName: this.editFileName
        }

        await AgentAttachmentApi.editAttachment(this.activeAgentId, data)
        await this.initAttachmentData()

        const title = this.$t('success')
        const message = this.$t('editNameSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.closePopup()
      this.stopLoading()
    },
    _validateData: function () {
      if (this.editFileName === '') {
        let message = this.$t('pleaseEnterFileName')
        this.alertError(message)

        return false
      }

      return true
    },
    _removeAttachmentFile: async function (attachFile) {
      this.startLoading()

      try {
        const data = {
          id: attachFile.id,
          fileUrl: attachFile.path
        }

        await AgentAttachmentApi.removeAttachment(this.activeAgentId, data)
        await this.initAttachmentData()
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    getCreatedAt: function (unixTime) {
      const createdAt = new Date(unixTime)

      return dateFormat.long(createdAt)
    },
    getDocumentName: function (name) {
      if (name.length > 40) {
        return `${name.substring(0, 36)}...`
      }

      return name
    },
    onClearButtonClick: async function () {
      this.isSearching = true
      this.keyword = ''

      await delay(300)
      this.isSearching = false
    },
    _filterAttachmentList: function () {
      const searchKeys = ['name']
      const dataList = this._sortByCreatedAt(this.attachmentList)
      this.attachmentDataList = filterDataByKeyword(dataList, this.keyword, searchKeys)
    },
    _sortByCreatedAt: function (dataList) {
      const result = dataList.sort((a, b) => {
        return (a.createdAt > b.createdAt) ? -1 : 1
      })

      return result
    }
  }
}

</script>

<style scoped>
  .el-table th {
    background-color: #eeeeee;
  }

  .el-form > div {
    text-align: left;
  }

  .upload-container {
    /*border: solid 1px #409EFF;*/
    border-radius: 5px;
    padding: 10px 0;
  }

  .table-attachment-list {
    width: 100%;
    margin-bottom: 22px;
  }

  .table-attachment-list td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    font-size: 14px;
  }

  .lastest-file {
    font-weight: 600;
  }
</style>
